import React, { Fragment } from "react";
import Popup from "reactjs-popup";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFileAlt, faFolderOpen } from "@fortawesome/free-solid-svg-icons";

type MyState = {};
type MyProps = {
    Key: string;
    ServerName: string;
    ServerIP: string;
    JoinIP: string;
    ServerCode: string;
    ServerType: string;
    ServerPort: string;
    JoinPort: string;
    ServerMap: string;
    ServerVersion: string;
    ServerID: string;
    PlayersOnline: number;
    Region: string;
};


export class ServerBox extends React.Component<MyProps, MyState> {
    
    constructor(props: MyProps) {
        super(props);
        this.HideAnswer = this.HideAnswer.bind(this);
        this.state = {};
    }
    componentDidMount() { }
    HideAnswer(e: any) {
        e.preventDefault();
        e.stopPropagation();
    }
    // Extremely hacky
    convertToGuidesLink(input: string, mapName: string) {
        if (mapName === "PANDAHUT RP LARGE PEI") {
            return "RP-13-(PEI-Large)";
        }
        switch (input) {
            case "Roleplay":
                return "RP-10-(Washington)";
        }
        if (input.startsWith("Unturnov 1.5")) {
            return "Unturnov-1.5-(12,-14)";
        }
        if (input.length === 0 || input.includes(" ") === false) {
            return input;
        }
        switch (input.split(" ")[0]) {
            case "Normal":
                return "Normal-Economy";
            case "Unturnov 1.5":
                return "Unturnov-1.5-(12,-14)";
            case "Unturnov":
                return "Unturnov-1.25-(19)";
            case "Roleplay":
                return "RP-10-(Washington)";
        }
        return input.split(" ")[0];
    }
    
    getCardDisplayStatus(serverName: string) {
        if (!serverName.includes("#342") && !serverName.includes("Secret") && !serverName.includes("#13"))
            return "show";
        else
            return "hide";
    }

    downloadFile(url: string, filename: string) {
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'downloaded-file'; // Provide a default filename
        document.body.appendChild(a); // Append to body (optional but recommended)
        a.click();
        document.body.removeChild(a); // Remove from body
    }

    downloadTextFile(filename: string, text: string) {
        const blob = new Blob([text], { type: "text/plain" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = filename;

        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    DlLog(serverNumber: string) {
        console.log("Trying to find element with ID " + serverNumber);
        if (document.getElementById(`dllog-${serverNumber}`) !== null && document.getElementById(`dllog-${serverNumber}`) !== undefined) {
            document.getElementById(`dllog-${serverNumber}`)?.click();
            //this.downloadTextFile("Rocket.log", `https://pvplogs.pandahut.net/PvPLogs/${serverNumber}/Rocket.log`);            
        }
        else
            console.log(`ERROR: Could not find element with ID dllog-${serverNumber}`);
    };

    BrowseLogs(serverNumber: string) {
        console.log("Trying to find element with ID " + serverNumber);
        if (document.getElementById(`dllog-${serverNumber}`) !== null && document.getElementById(`dllog-${serverNumber}`) !== undefined) {
            window.location.href = `https://pvplogs.pandahut.net/PvPLogs/${serverNumber}/`;
        }
        else
            console.log(`ERROR: Could not find element with ID dllog-${serverNumber}`);
    };

    viewLog(serverNumber: string) {
        console.log("Trying to find element with ID " + serverNumber);
        if (document.getElementById(`viewlog-${serverNumber}`) !== null && document.getElementById(`viewlog-${serverNumber}`) !== undefined) {           
            document.getElementById(`viewlog-${serverNumber}`)?.click();
        }
        else
            console.log(`ERROR: Could not find element with ID dllog-${serverNumber}`);
    };

    render() {
        const viewRawLogEl = <i className="btnicon"><FontAwesomeIcon icon={faFileAlt} /></i>
        const browseLogsEl = <i className="btnicon"><FontAwesomeIcon icon={faFolderOpen} /></i>
        const logViewerEl = <i className="btnicon"><FontAwesomeIcon icon={faEye} /></i>
        const serverNameCapitalized = ResolveServerName(this.props.ServerIP, true);
        const serverNameLower = ResolveServerName(this.props.ServerIP, false);
     
        return (
            <div className={`card ${this.getCardDisplayStatus(this.props.ServerName)}`}>
                <a id={`viewlog-${serverNameLower}`} href={`https://pvplogs.phn.pw/log?log=${serverNameLower}`} className="displayNone" style={{ display: "none" }} > </a>
                <a id={`dllog-${serverNameLower}`} className="displayNone" href={`https://pvplogs.pandahut.net/PvPLogs/${serverNameCapitalized}`} download={`Rocket_${serverNameCapitalized}.log`}> </a>
                <a id={`extlog-${serverNameLower}`} className="displayNone" href={`https://pvplogs.pandahut.net/PvPLogs/${serverNameCapitalized}/`}> </a>

                <div id={`${serverNameLower}`} className="img-wrap-card card-img-wrapper" style={{ backgroundImage: `url('https://phcdn.pandahut.net/Maps/${this.props.ServerMap.replace(/\s/g,'')}.png')` }}>
                    <a id={`rawlog-${serverNameLower}`} href={`https://pvplogs.pandahut.net/PvPLogs/${serverNameCapitalized}/Rocket.log`} download={`Rocket_${serverNameCapitalized}.log`}>
                        <div className="card-button card-button-one">
                            {/*<div className="card-button card-button-one" onClick={() => this.DlLog(`${serverNameLower}`)}>*/}
                            <span className="button-one-title">{viewRawLogEl} Raw Log File</span>
                        </div>
                    </a>
                    <div className="card-button card-button-two" onClick={() => this.BrowseLogs(`${serverNameLower}`)}>
                        <span className="button-one-title">{browseLogsEl} Browse Logs</span>
                    </div>
                    <div className="card-button card-button-three" onClick={() => this.viewLog(`${serverNameLower}`)}>
                        <span className="button-one-title">{logViewerEl} LogViewer</span>
                    </div>
                </div>
                        
                {/*<img src={`https://phcdn.pandahut.net/Maps/${this.props.ServerMap.split(" ").join("")}.png`} alt={`${this.props.ServerMap}`} />*/}
                        
                <div className="card-flap">
                    <div className="card-description">
                        <ul className="alignLeft">                            
                            <li><span className="strongTitle">{ConcatServerName(this.props.ServerName)}</span></li>
                            <li>Map: <strong>{this.props.ServerMap}</strong></li>
                            <li>Server Code: <strong>{this.props.ServerCode}</strong></li>
                            <li><span>Players:</span>{" "}<strong>{this.props.PlayersOnline}/220</strong></li>
                        </ul>                        
                    </div>
                </div>
                
            </div>
        );        
    }
}

                       
function capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

function ConcatServerName(serverName: string): string {
    if (serverName === null || serverName === undefined) {
        return "Pandahut [Unknown]";
    }
    return serverName.slice(0, 50);
}

function ResolveServerName(serverDNS: string, capFirstLetter: boolean): string {
  if (serverDNS === null || serverDNS === undefined) {
    return "1";
  }
    
  let serverNameStr = serverDNS.replace(".pandahut.net","");      
    
  if (capFirstLetter === true)
      serverNameStr = capitalizeFirstLetter(serverNameStr);
    
  return serverNameStr;  
}

export default ServerBox;
